// src/pages/Dashboard.js
import React from 'react';
import DashboardComponent from '@/components/dashboard/Dashboard';

const DashboardPage = () => {
    return <DashboardComponent />;
};

export default DashboardPage;
